import './utils/safariPolyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "App";

import './index.css';
import 'utils/assets/css/common.css';
import 'utils/assets/css/ui-na.css';
import 'utils/assets/css/AssignmentReview.css';
import 'utils/assets/css/StudentReview.css';
import 'utils/assets/css/wholeSomeStyling.css';
import '@ant-design/v5-patch-for-react-19';
import 'antd/dist/reset.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'suneditor/dist/css/suneditor.min.css';
import 'animate.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'components/VocabQnAModal/index.css';
import 'split-pane-react/esm/themes/default.css';

import 'utils/assets/css/customStyle.css';
import 'containers/customStyle.css';
import './custom-style.css';
import 'utils/assets/css/commonStyles.css';
import 'utils/assets/css/picassoStyling.css';

import * as Sentry from '@sentry/react';
import config from 'config';
import { initApp } from 'utils/config/initApiConfig';
initApp();
const isProduction = window.location.hostname === 'nosotrosonline.com';
const dns_url = window.location.hostname.includes('staging') ? config.sentry_dns_stg : config.sentry_dns
if (!window.__SENTRY_INIT_DONE__) {
    window.__SENTRY_INIT_DONE__ = true;
    Sentry.init({
    dsn: dns_url,
    integrations: (integrations) => {
        const next = [
            Sentry.browserTracingIntegration(),
            ...integrations.filter((i) => i.name !== 'Replay'),
        ];
        if (isProduction) {
            next.push(Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
                networkDetailAllowUrls: [
                    window.location.origin,
                    /https:\/\/.*\.amazonaws\.com/,
                ],
                networkRequestHeaders: ['Cache-Control'],
                networkResponseHeaders: ['Referrer-Policy'],
            }));
        }
        return next;
    },
    tracesSampleRate: 0.1,
    tracePropagationTargets: ['localhost', 'nosotrosonline'],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: isProduction,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    dist: import.meta.env.VITE_SENTRY_RELEASE,
    beforeSend(event) {
        try{
        const frames = event.exception?.values?.flatMap((value) => value.stacktrace?.frames || []) || [];
        const hasNodeModulesFrame = frames.some((frame) => {
            const filename = frame?.filename || '';
            return typeof filename === 'string' && (filename.includes('/node_modules/') || filename.includes('\\node_modules\\'));
        });
        if (hasNodeModulesFrame) return null;

        const err = event.exception?.values?.[0]?.value || event.message || '';
        if (typeof err === 'string') {
            if (err.includes('Large HTTP payload')) return null;
            if (err.includes('NetworkError') || err.includes('Network Error') || err.includes('network error')) return null;
            if (err.includes('Failed to fetch') || err.includes('fetch')) return null;
            if (err.includes('ERR_NETWORK') || err.includes('ERR_INTERNET_DISCONNECTED')) return null;
        }
        return event;
        }catch(error){
            console.log(error, "error in beforeSend")
            return event;
        }
    }
});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);